import base64 from 'base-64';
import { useMemo } from 'react';

type Input = {
  width: number;
  height: number;
};

/**
 * Create shimmer effect svg in base64 based string.
 * Expected to be used with `Image` from next.js component
 */
export const useShimmerDataUrl = ({ width, height }: Input): string => {
  return useMemo(() => {
    const svgStr = `<svg width="${width}" height="${height}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <linearGradient id="g">
                  <stop stop-color="#eeeeee70" offset="20%" />
                  <stop stop-color="#eeee" offset="50%" />
                  <stop stop-color="#eeeeee70" offset="70%" />
                </linearGradient>
              </defs>
              <rect width="${width}" height="${height}" fill="#eeeeee70" />
              <rect id="r" width="${width}" height="${height}" fill="url(#g)" />
              <animate xlink:href="#r" attributeName="x" from="-${width}" to="${width}" dur="1s" repeatCount="indefinite"  />
            </svg>`;

    return `data:image/svg+xml;base64,${base64.encode(svgStr)}`;
  }, [width, height]);
};
